module.exports = __webpack_public_path__ + "static/media/6.7f63e4d0.jpeg";